import { AxiosResponse } from 'axios';
import { toast } from 'helpers/AlertHelper';
import { t } from 'i18next';
import { BillTypes } from 'models';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { addProductToBillAPI, getBillTableAPI, updateBillAPI } from 'redux/api';
import { billAction } from 'redux/slices/billSlice';
import { getShopSettingsAPI } from 'redux/api/shopApi';
import { RootState } from 'redux/store';
import * as socket from '../../sockets';
import { totalProductPrice, getPriceWithRounding, getTotalPaymentWithRounding } from 'utils';

function* getBillByTableSaga(action: any) {
  try {
    const response: AxiosResponse<BillTypes[]> = yield call(getBillTableAPI, action.payload);

    yield put(billAction.getBillByTableSuccess(response.data));
  } catch (error) {}
}

function* addProductInBillSaga(action: any) {
  const token_order: string = yield select((state: RootState) => state.auth.token_order);
  try {
    const response: AxiosResponse<any> = yield call(
      addProductToBillAPI,
      {
        ...action.payload,
        token_order,
      },
      {
        app_name: action.payload.app_name,
      }
    );

    if (response.data.message === 'bill paid') {
      toast(t('BILL_PAID'), 'error');
      return;
    }

    if (response.data.message === 'token_order_expired') {
      toast(t('TOKEN_ORDER_IS_EXPIRED'), 'error');
      return;
    } else {
      yield put(billAction.addProductInBillSuccess(response.data));

      if (action?.payload?.shop_id) {
        let products = response.data;
        // Realtime Product in bill
        socket.clientAddProductInBill({
          products,
          preOrder: products,
          shop_id: action.payload?.shop_id,
        });

        // Realtime bill
        const res_bill: AxiosResponse<BillTypes[]> = yield call(getBillTableAPI, {
          table_id: action.payload?.table_id,
          shop_id: action.payload?.shop_id,
          appName: action.payload?.appName,
        });

        if (res_bill?.data?.length > 0) {
          const billCurrent = res_bill.data.find((i) => i?.id === action.payload?.bill_id);
          const resShopSettings: AxiosResponse<any> = yield call(getShopSettingsAPI, {
            shop_id: action.payload?.shop_id,
            bill_id: action.payload?.bill_id,
            token_order,
            appName: action.payload?.appName,
          });

          if (billCurrent) {
            const totalProduct = totalProductPrice({
              bill: billCurrent,
              details: products,
            });

            const totalProductVAT = totalProductPrice({
              bill: billCurrent,
              details: products,
              taxCalc: 'VAT',
            });
            const totalProductTAX = totalProductPrice({
              bill: billCurrent,
              details: products,
              taxCalc: 'TAX',
            });

            const round_money_get = () => {
              return (
                getTotalPaymentWithRounding({
                  finalTotal: billCurrent?.total_payment,
                  billInfo: billCurrent,
                  shopSettings: resShopSettings,
                  noCardFee: 'noCardFee',
                }) -
                getTotalPaymentWithRounding({
                  finalTotal: billCurrent?.total_payment,
                  billInfo: billCurrent,
                  shopSettings: resShopSettings,
                  isWithoutRounding: 'not-rounding',
                  noCardFee: 'noCardFee',
                })
              );
            };

            console.log(round_money_get());
            let total_payment =
              totalProduct +
              totalProductVAT +
              totalProductTAX +
              (billCurrent?.total_payment || 0) -
              round_money_get();
            console.log('total_payment', total_payment);

            total_payment = getPriceWithRounding(total_payment, resShopSettings?.data);

            const res: AxiosResponse<any> = yield call(
              updateBillAPI,
              action.payload?.bill_id,
              {
                total_payment,
                shop_id: action.payload?.shop_id,
                bill_id: action.payload?.bill_id,
                token_order,
              },
              { app_name: action.payload.app_name }
            );

            if (res?.data?.data) {
              socket.clientUpdateBill({
                ...res.data.data,
                shop_id: action.payload?.shop_id,
              });
            }
          }
        }
      }
      toast(t('ORDER_SUCCESS'), 'success');
      if (typeof action.payload?.onSuccess === 'function') {
        action.payload?.onSuccess();
      }
    }
  } catch (error: any) {
    console.log(action.payload);
    if (typeof action.payload?.onErrors === 'function') {
      action.payload?.onErrors();
    }
    console.log(error);
    if (error?.response?.data?.message === 'token_order_expired') {
      toast(t('TOKEN_ORDER_IS_EXPIRED'), 'error');
    }

    if (error?.response?.data?.message === 'no_token_order') {
      toast(t('NO_BILL'), 'error');
    }

    if (error.response?.data.message === 'bill_delete') {
      toast(t('NO_BILL'), 'error');
    }
  }
}

export default function* billSaga() {
  yield takeLatest(billAction.getBillByTable, getBillByTableSaga);
  yield takeLatest(billAction.addProductInBill, addProductInBillSaga);
}
